import {unitOfTime} from 'moment/moment';

export enum ComponentView {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  DAY = 'DAY'
}

export enum ComponentViewDisplay {
  SELF,
  SELF_FULL,
  PARENT
}

export class TimelineConfig {
  minYear = 1970;
  maxYear = 3000;
  view: ComponentView = ComponentView.MONTH;
  minView: ComponentView = ComponentView.DAY;
  maxView: ComponentView = ComponentView.YEAR;

  viewHierarchy: Map<ComponentView, ComponentView> = new Map([
    [ComponentView.YEAR, ComponentView.YEAR],
    [ComponentView.MONTH, ComponentView.YEAR],
    [ComponentView.DAY, ComponentView.MONTH]
  ]);
  momentUnits: Map<ComponentView, unitOfTime.Base> = new Map([
    [ComponentView.YEAR, 'year'],
    [ComponentView.MONTH, 'month']
  ]);
  dateFormats: Map<ComponentView, DateFormat> = new Map([
    [ComponentView.YEAR, {
      self: 'YYYY', key: 'YYYY', full: 'YYYY', parent: 'YYYY'
    }],
    [ComponentView.MONTH, {
      self: 'MMM', key: 'YYYY-MM', full: 'MMM YYYY', parent: 'YYYY'
    }],
    [ComponentView.DAY, {
      self: 'D', key: 'YYYY-MM-DD', full: 'D MMM YYYY', parent: 'MMM YYYY'
    }]
  ]);

  viewBounds: Map<ComponentView, number> = new Map([[ComponentView.YEAR, 7]]);
  defaultViewBound = 1;

  readonly viewSelectionOptions: ComponentView[] = [ComponentView.YEAR, ComponentView.MONTH, ComponentView.DAY];
}

interface DateFormat {
  self: string;
  key: string;
  full: string;
  parent: string;
}

export interface TimelineDataSet {
  timelineData: TimelineData[];
}

export interface TimelineData {
  name?: string;
  dateField: string;
}

export interface TimelineDataSegment {
  data: Data[];
  range: DateRange;
}

export interface TimelineDataSegmentHandler {
  timelineData: TimelineData;
  data: Data[];
}

export interface Data {
  [x: string]: any;
}

export interface NodeSelection {
  open?: boolean;
  date?: Date;
  data?: Map<TimelineData, Data[]>;
}

export interface DateRange {
  from: Date;
  to: Date;
}

export interface NodeClickEvent {
  event: MouseEvent;
  date: Date;
}

export interface TimelineScroll {
  scrollHandler?: number;
  scrollBuffer: number;
  scrollHandlerInterval: number;
}

export interface TimelineDrag {
  mousePressed?: boolean;
  startX?: number;
  scrollLeft?: number;
}
